<template>
  <div>
    <h2>The House of Stuart and Jacobitism, 1603-1746</h2>
    <h3>The Stuart Monarchy 1603-1691</h3>
    <p>
      James I and VI ruled England, Scotland and Ireland from 1603 to 1624. He
      was the cousin of Elizabeth I and son of Mary, Queen of Scots, and the
      first Stuart monarch of England. While on the Throne of England, he sought
      the union of Scotland and England but was rebuffed by the English
      Parliament. Once he accepted the English throne, he never returned to
      Scotland and ruled it through a Scottish Privy Council. He was
      instrumental in the establishment of English and Scottish settlements in
      Ireland, called Plantations, displacing Irish Catholic natives.
      <br>
      <br>James was followed by his son, Charles I, who ruled from 1624
      to1649. He was a Protestant but irritated English Protestant Puritans with
      his tolerance of Catholics and failure to include any, but a few
      favorites, in his policy and decision making. His wife was a Catholic,
      cousin to the King of France and made every effort to convert her children
      to Catholicism. Charles fought with an English army against Scotland in
      1638 and 1640 over the imposition of an English prayer book in Scottish
      churches and was defeated. His Irish Catholic subjects revolted in 1641 in
      hopes of religious toleration after seeing the concessions granted the
      victorious Scots in 1640. The Irish revolt forced Charles to turn to his
      English Parliament for money to raise an army. Parliament and the King
      could not agree on any of the issues before them and went to war against
      each other. Scotland plunged into civil war as well, the government
      supporting first Parliament, then Charles I, when he was imprisoned by the
      English Parliament. The Marquis of Montrose conducted a brilliant campaign
      against the Scottish Covenanter government with Irish mercenaries and
      highlanders in 1644-45 until he was defeated at Phillipaugh. After the
      murder of Charles in 1649, the Scots crowned Charles II as their King and
      invaded England in 1650, suffering defeat and invasion by Cromwell and his
      English Army after Charles fled and left then to their fate. After
      subduing Scotland, Cromwell went on to end the bewilderingly complicated
      multi-faction civil war in Ireland and slaughtered or relocated the
      Catholic Irish inhabitants. Cromwell ruled England, Scotland and Ireland
      until his death in 1659, and was replaced by his incompetent son.
      <br>
      <br>Charles II, already King of the Scots, was invited in 1660 to take
      the Throne of England and Ireland and ruled all three until 1685.
      Disdainful of Scotland, he never saw it after 1651, but ruled it through a
      Scottish Privy Council that brutally suppresses the dissenting Lowland
      Protestants. Charles successfully resisted his mother’s influence and
      remained a Protestant until his deathbed conversion to Catholicism. His
      younger sister, Minette, became a Catholic and married the brother of
      Louis XIV. James, Duke of York, the heir to the Throne, made a very public
      declaration of his conversion to Catholicism causing a crisis in which
      Charles’ support of James as his successor never wavered.
      <br>
      <br>After the death of Charles II, James II and VII, ruled uncontested
      from 1685-1688. The Protestant English were disturbed by his Catholicism,
      as well as his inclination to place fellow Catholics in positions of
      authority in the army and government, but tolerated him as long as they
      knew he would be followed by one of his Protestant daughters. James was
      more familiar with Scotland, having ruled it for his brother for a time,
      but still ruled it in absentia with a Scottish Privy Council. There was a
      crisis in England when James’ wife, Mary of Modena, gave birth to a son,
      creating the possibility of a second Catholic Monarch to follow James. A
      cabal of Protestants in the government approached William of Orange, son
      in law to James and staunch Protestant, to invade England to assure the
      “Protestant Rights of Englishmen.” He landed in November of 1688. The
      English army went over to William of Orange and James, his family, and
      many of his adherents, fled England for France. The English Parliament
      declared him to have abdicated the Throne after he left.
      <br>
      <br>The English Parliament offered William of Orange and his wife Mary,
      James’s eldest daughter the Throne on 31 January 1689, which they accepted
      jointly. In April 1689 the Scottish Convention of the Estates decided that
      James had forfeited the Scottish crown and recognized William and Mary as
      monarchs II of Scotland. There was some resentment in Scotland and all was
      quiet until Viscount Dundee raised a 2000 man army loyal to James in the
      Western Highlands in June 1689. Dundee’s army won at the pass of
      Killiekrankie in 1689 with a single highland charge sustaining losses of
      as much as 30% of the force due to the firepower of General MacKay’s army.
      With Dundee’s death on the battlefield, the supporters of James had no
      real leadership and after defeats at the battles of Dunkeld and Cromdale,
      the army disbanded. In 1689 James landed in Ireland and began a military
      campaign to subdue the island and invade England. He was opposed by Scots
      and English Protestants who held him at bay until the English and Dutch
      Armies arrived and defeated him at the Boyne River, after which James
      returned to France. The Army of James was defeated and forced to surrender
      and depart for France in 1691.
      <br>
      <br>Like this and all subsequent Stuart attempts to regain the Throne of
      England, Ireland and Scotland, support from France was minimal and
      demonstrated a willingness to support the Stuarts as long as France was at
      war with England while involving as few troops and spending at little as
      possible.
      <br>
      <br>In 1691 the government in Scotland established a deadline of 1
      January 1692 for all the clan chiefs to take a loyalty oath to William. In
      the view of the clan chiefs, permission to take this oath had to be
      granted by James, which was forthcoming on 29 December 1691. There was a
      failure to meet a series of unexplained, inflexible administrative
      requirements in the case of the loyalty oath of Alasdair MacIan, chief of
      the MacDonald’s of Glencoe and he was not on the list of “loyal” clan
      chiefs. Robert Campbell of Glenlyon arrived in Glencoe on 12 February with
      120 men, enjoyed the hospitality of the MacDonalds for 12 days. Before
      dawn on the 12th day Campbell and his men massacred or turned the
      occupants of three villages out into the snow. The only punishment for the
      massacre was the dismissal of the Scottish Secretary of State. The
      Campbells were not rewarded with MacDonald land, as they had hoped, and
      the highland nobility trusted the government less than they had before.
    </p>
    <h3>Kings in Exile 1692-1744</h3>
    <p>
      In 1694 Mary died, leaving the unpopular William to rule alone. At the
      1697 Peace of Ryswick between France and England the French recognized
      William as King of England, and agreed to permanently stop all military
      support to James. James left France for Rome.
      <br>
      <br>In 1698 many in Scotland realized that the accumulation of wealth
      required colonial possessions and being hindered from access to English
      colonies, a subscription was raised from all of Scotland to establish a
      colony in Central America called Darien. The climate proved deadly and
      English support was denied to the point of refusing to send a relief
      expedition to the starving colony in 1699. The Darien settlement was
      abandoned in 1700 and with it went a considerable amount of Scottish
      capital.
      <br>
      <br>In 1701, James died and war broke out between England and France. On
      the death of James II and VII, his son, James Francis Stuart was
      proclaimed the King of England, Scotland and Ireland, James III and VIII
      in exile. In 1702 William died as a result of a riding accident in which
      his horse stumbled in a mole’s hole. This is the origin of the Jacobite
      toast to “that brown coated gentleman.” With the accession of childless
      Queen Anne, the youngest daughter of James II and VII, the English
      Parliament, with no Scottish consultation, passed an Act of Settlement
      which barred Catholics from English Throne. The Succession was conveyed to
      Sophia the Electress of Hannover and her heirs. This act ensured that King
      James could not take the English throne.
      <br>
      <br>In 1703 the Scottish the Parliament passed the Act of Security
      giving Scotland the right to decide who would be the monarch of Scotland
      and the Act of Peace and War giving Scotland the right to decide when it
      would go to war. Queen Anne reluctantly gave her assent, and the stage was
      set for the struggle over Scottish independence. The English Parliament
      passed the Alien Acts in 1705 effectively disrupting trade between
      Scotland and England and putting Scottish property rights in England at
      risk.
    </p>
    <h3>The Act of Union and “The 08”</h3>
    <p>
      Queen Anne directed a treaty of Union be negotiated between England and
      Scotland in 1705. There were a number of Scottish nobles who supported
      Union, due primarily to economic interests. Enough of those that were not
      initially supportive of union were convinced, usually by bribery, that it
      was in their best interests. The burghs represented in Parliament were,
      for the most part, consistently against the union but were overruled and
      out numbered by the nobles who supported union. Supporters of the Union
      were reimbursed for their losses from the Darien colony and were rewarded
      with representing Scotland in the English Parliament. Scotland did retain
      control of its separate legal system, church and educational system. The
      last Scottish Parliament met on 25 March, 1707. The act of Union ended
      Scottish independence as a separate kingdom and caused considerable
      hostility in Scotland, to the benefit of the Jacobite cause.
      <br>
      <br>In 1708 James attempted a landing in Scotland with French troops.
      The French naval commander refused to land troops as highlanders were
      rowing out to greet the fleet in the Firth of Forth. With the appearance
      of an English fleet, the French ships fled back to France.
      <br>
      <br>In 1713 the Terms of the Treaty of Utrecht between France and
      England forced James to leave France for Rome where he remained for the
      rest of his life. In the latter years of Anne’s reign there was
      considerable hope that she would approach James asking him to take the
      throne upon her death. James’ unwillingness to give up his Catholic faith
      in the end made such an option unacceptable to the English. Anne died on
      31 July 1714 and George, Elector of Hanover ascended to the Throne on 20
      October of that same year. George I was never popular with his English,
      Scottish and Irish subjects and was seen by many as a usurping foreigner.
      In England he displaced the Tory party, associated with a strong monarchy
      and the “High Church” Episcopalians with the Whigs who were interested in
      maintaining a constitutional monarchy. In Scotland the government fell
      under the control of the Presbyterian faction and the Episcopalians and
      small Catholic minority found themselves excluded from government because
      of their religious beliefs. Hostility to existing government, however, did
      not necessarily translate into supporting armed revolt, as the Jacobites
      were to learn repeatedly. The English reinstated a tax on malt in 1714
      that had been lifted at the Act of Union to curb the Scottish practice of
      making their own whiskey, the resulting riots and military suppression of
      those riots was another cause of widespread disaffection. In 1715 Louis
      XIV died but his successor Louis XV continued the policy of limited
      support to the Jacobites, ignoring them when at peace, and using them as
      an annoyance to the English when they were at war.
    </p>
    <h3>“The 15”</h3>
    <p>
      Taking advantage of widespread anti-Hanoverian and Anti-Union sentiment,
      the Earl of Mar raised the Jacobite standard on 6 September 1715 in the
      north-east Highlands without the Jacobite Court in exile’s knowledge.
      Individual motivation mattered little in Scottish highland, and to some
      extent, lowland societies where the landed aristocracy expected tenants to
      turn out in support of the landowners cause. Both the lowlands and
      highlands turned out equally for Mar in relatively large numbers.
      <br>
      <br>Inverness was occupied by the Jacobites on the 12 of September, but
      was back in government hands by November. Dundee was taken without a shot
      by Jacobite forces on 16 September and Perth fell to 40 Jacobites on the
      17th after a truce and surrender of arms by 150 plus government
      supporters. The seizure of these and other key towns made it possible to
      mass Jacobite contingents who were wandering directionless across
      Scotland. On 6 October, English Jacobites mustered and, upon being turned
      away by local government forces at Newcastle, took Hexam with a force of
      300 augmented by Scots from north of the Border. Victory by intimidation
      as opposed to actual combat was the rule during the early stages of the
      uprising.
      <br>
      <br>In September government forces began moving into Scotland from
      England and Ireland but not in sufficient numbers to satisfy the
      government military commander in Scotland, the Duke of Argyll. The
      government remained, throughout the uprising, more concerned about keeping
      the peace in England, Ireland and Wales than operations in Scotland, and
      their subsequent troop deployments reflected that concern. Argyll,
      outnumbered by the Jacobites, established a blocking position along the
      river Tay and continued to recruit and train government supporters to
      augment his army of approximately 3,500 regulars.
      <br>
      <br>Throughout October, small scale raiding by both sides ensued in
      Scotland while the Jacobites trained, recruited and armed their unprepared
      soldiers. A southern Scottish and northern English army began to coalesce
      in early October and made its way into England on 1 November with
      approximately 1,400 men. It proceeded south unopposed, and was reinforced
      with only perhaps as many as 200 men, until it got to Preston. At Preston,
      government forces surrounded the Jacobite army in the town on the 12 of
      November and accepted the Jacobite surrender on the 14th.
      <br>
      <br>By the first of November the Earl of Mar had assembled a force of
      approximately 9,000 soldiers at Perth from the west and east of Scotland.
      The Jacobite force under the command of General George Hamilton moved
      south towards the Forth west of Stirling on the 11th in an effort to
      outflank Argyll’s forces. Argyll’s moved towards Mar’s force, resulting in
      a meeting engagement at Sherrifmuir in 13 November. Both armies’ left
      flank’s were routed by cavalry almost simultaneously, creating a chaotic
      situation for both armies. Argyll’s exhausted forces retreated in the face
      of the equally exhausted Jacobite force. Government forces lost
      approximately 1,000 men it could ill afford and the Jacobites lost
      approximately 1,500. Jacobite losses were exacerbated by the departure of
      as many as half of the remaining army of 7,500 after the battle.
      <br>
      <br>After Sherrifmuir, some of the Scottish nobles attempted to
      negotiate a peace with the Duke of Argyll. Argyll was in favor of offering
      an honorable peace but the English government insisted on total
      capitulation. The unwillingness of the government to negotiate gave the
      Jacobites nothing to lose and increased the will to resist and hope of
      French support.
      <br>
      <br>In early December, General Cadogan arrived in Scotland to take
      command of government forces, replacing the Earl of Argyll and setting the
      stage for a more aggressive approach to dealing with the Scottish
      Jacobites. James arrived in Scotland on 22 December with 2 attendants, no
      money, no arms and no soldiers while many Scottish nobles had returned to
      their estates to begin gathering their forces for the coming spring
      campaign.
      <br>
      <br>On the 27th of January government forces launched a winter offensive
      from Stirling and Dunblane to Perth unopposed. The Jacobites retreated
      from Perth to Dundee. The government army had no artillery and was, low on
      rations and marching in near arctic winter conditions as the Jacobites
      retreated from defenses in Perth and then in Dundee. The Jacobite army
      arrived at Montrose on 1 February, demoralized by desertion and down to
      approximately 4,000 men. The Jacobite army remained in Montrose until 5
      February, the day after James returned to France, and disbanded into small
      units that eventually went home.
    </p>
    <p class="center">* * *</p>
    <p>
      Many of those English participants in the 15 that did not flee to France
      were executed or transported. Government soldiers were garrisoned
      throughout northern England and Catholics were fined regardless of their
      involvement in the uprising. In Scotland there were few leaders imprisoned
      or fined. Some did flee for France with the majority of participants
      permitted to return to their pre-uprising lives. The harshest penalty
      suffered by the Scots was a Disarming Act of 1716 forbidding all Scots in
      the highlands, regardless of loyalty, from carrying weapons.
      <br>
      <br>In 1719, an Anglo-French alliance declared war on Spain. In an
      effort to open a second front, the Spanish and Jacobites planned an
      invasion of England with a small diversionary force in Scotland. The main
      force was destroyed in bad weather but the diversionary force landed at
      Loch Duich with 300 soldiers led by Lord Tullibardine and Earl Marischal.
      This force was joined by a group of Jacobite exiles from France. There was
      little support from the Scots. Government forces from Inverness met the
      dug in Jacobite force, both with about 1,000 troops, at Glenshiel and
      defeated them with the Spanish surrendering and Scots disappearing into
      the highlands. That same year James married Climentia Sobieski the
      following year his son and heir Charles Edward born, followed by another
      son Henry in 1725.
      <br>
      <br>General George Wade was appointed the military commander of North
      Britain in 1724. His first act was to put down malt tax riots in Glasgow.
      In 1725 General Wade began construction of a road network n the highlands
      to facilitate the movement of men and materiel. By 1738 the network
      consisted of approximately 242 miles. Under his command, a total of six
      independent companies were reformed, as they had been off and on since
      1603, to police the highlands. Wade constructed Fort George at Inverness,
      transformed Fort Augustus from barracks to a fort and reinforced 17th
      century Fort William, the southernmost of the forts in the Great Glen.
      Other lesser garrisons were established at Ruthven and Bernera. In 1727
      George I died, and the equally unpopular George II ascended to the Throne.
      <br>
      <br>Scottish efforts to avoid payment of the hated malt tax resulted in
      aggressive smuggling of malt from Germany. In 1736, the arrest of three
      smugglers and execution of one of them resulted in riots in the death of
      six rioters at the hands of the Edinburgh City Guard. The commander of the
      City Guard, John Porteous, was charged with murder, sentenced to death and
      lynched by a mob before the sentence could be appealed or carried out.
      <br>
      <br>In 1740 the War of Austrian Succession between France and Britain
      created renewed interest on the part of the French in opening a second
      front to distract the English on the continent. Seeing the opportunity for
      a Jacobite uprising in Scotland, a group of nobles sent a petition to the
      French in March of 1741 promising an army of 20,000 soldiers if the French
      sent the Irish Brigade to Scotland. There was no response to the petition.
      <br>
      <br>A French force was assembled for an invasion of England and Scotland
      in early 1744. The invasion force consisted of 20,000 French regulars. The
      3,000 man Irish Brigade under the Earl Marischal was to be a diversionary
      force landing in Scotland. Prince Charles was summoned from Rome to France
      to represent his father as Prince Regent in England. As the invasion fleet
      was about to sail in February 1744 a gale blew up which dispersed and
      decimated the warships which were to protect the ships transporting the
      troops. The troop transports were destroyed or damaged in Dunkirk harbor
      by two successive storms in February and March and the invasion was called
      off. This was the last planned large scale French effort on behalf of the
      Jacobites.
      <br>
      <br>In late 1744 Charles was introduced to a group of Irish privateers
      and slaver traders who operated out of northern French ports. They had
      Jacobite sympathies, a desire to distract the Royal Navy from their
      privateering activities and supported Prince Charles in his effort to take
      troops, arms, ammunition, himself and his companions to Scotland. Charles
      embarked on a planned invasion without the knowledge or support of Louis
      XV, relying on limited support from one of his ministers. Charles did not
      his father, James, of his plans.
    </p>
    <h3>Charlie’s Year 1745-46</h3>
    <h4>“Bliadhna Thearlaich”</h4>
    <p>
      Charles was convinced of Scottish lingering disaffection over the Union of
      1707 and the imposition of English taxes, particularly the malt tax. There
      was considerable talk and some correspondence between the Jacobite and
      several Scots nobles indicating their unhappiness with the current state
      of affairs. The correspondence from the Scots Jacobites always emphasized
      the need for French forces to serve as the core of any army raised in
      Scotland and that Charles need not come to Scotland without them.
      Adherents of the large Scottish Episcopal Church were a major source of
      support for the Jacobite cause, and made it clear they were willing to
      overlook James’ Catholicism, unlike many of the lowland Presbyterians. The
      small Scottish Catholic minority was willing to support James if granted
      toleration, but in the case of Keppoch’s regiment and others, when they
      were denied their own Priest they deserted.
      <br>
      <br>Charles was equally convinced that English disaffection over the
      imposition of excise and property taxes and a legal code that favored the
      propertied classes would result in armed support. This view was more
      informed by his Irish councilors in France than any intelligence gathered
      in England. His English supporters promised little, and in the final
      analysis, delivered less.
      <br>
      <br>After writing letters to his father and Louis XV asking for support,
      delivered after his departure, Charles put together an expedition of two
      ships, one a light frigate, the "Du Teillay", the other a much larger
      French naval vessel of 64 guns, the "Elisabeth" which set sail from the
      Loire on 5 July 1745. On 9 July they encountered the British 54 gun HMS
      “Lion,” which damaged Charles' larger ship so badly it had to return to
      France. It was carrying all of the Prince’s troops and most of his arms
      and ammunition. Charles landed on the island of Eriskay on 23 July 1745
      with “The Seven Men of Moidart,” comprised of only two expatriate
      Scotsmen, the rest being three Irishmen, one Frenchman and an Englishman.
      He also brought 1,500 firelocks, 1,800 swords and 4,000 Pounds Sterling in
      gold. Thomas Sheridan and John O’Sullivan, two of the Irishmen in his
      company, would be the faction in Charles’ Council of War that was
      continuously at odds with the Scots field commanders, who tended to follow
      Lord George Murray’s lead. Charles arrived on the mainland at Loch nan
      Uamh on 25 July. On 7 August, the Duke of Argyle was made aware of the
      landing and the government in London was informed.
      <br>
      <br>Initially the clan chiefs who meet with him were unenthusiastic
      about an uprising, given the absence of French forces and the government
      retribution after 1715. Once Charles secured the reluctant support of
      Cameron of Lochiel, other clans began to turn out in support of the
      uprising. The first engagement took place on 16 August when two newly
      recruited companies of the government’s Royal Regiment of Foot were
      defeated between Fort Augustus and Fort William. On 19 August the Jacobite
      standard was raised at Glenfinnian in the presence of approximately 1200
      men. On 20 August, the government in London requested troops on the
      continent be sent back to England, not so much in response to Charles
      army, but more to defend England from a French invasion which was
      perceived as the greater threat at the time. General Cope set out with a
      government army of 3,000 to march from Edinburgh to Fort Augustus in the
      Great Glen. He diverted the army north to Inverness to avoid the Jacobite
      controlled Corrieairack Pass, arriving at Inverness on 29 August. In an
      effort to secure food for the Jacobite army, Colonel O’Sullivan, with no
      artillery, engineers and only Highland troops failed in an attempted siege
      of the government Ruthven Barracks on 30 August. Charles took Perth on 3
      September with approximately 3000 soldiers. At Perth, Charles was joined
      by the Duke of Perth and his brother, Lord George Murray, the most
      experienced officer in the Jacobite army. The Jacobite army now numbered
      approximately 4,000 men. The Jacobite army left Perth on 11 September and
      was at Stirling on 13 September.
      <br>
      <br>The Jacobite Army moved on to Edinburgh. Edinburgh at the time was
      one of the four largest population centers in Britain with a population of
      approximately 50,000. A detachment under Lochiel entered the city early on
      the morning of 17 September through a gate mysteriously left open. All but
      the castle capitulated and the local populace proved to be unsupportive.
    </p>
    <h3>Prestonpans</h3>
    <p>
      General Cope moved south from Inverness and arrived near Aberdeen on the
      19th. He took up a position at Prestonpans with stone walls on his right,
      a bog on his left, a ditch to the front and the sea to his rear on 20
      September. It was a defensive position with no means of escape or
      withdrawal. The Jacobite army repositioned twice on the 20th and suffered
      from confusion as a result of its effort to find suitable terrain from
      which to attack Cope’s stationary force. Before dawn the Jacobites seized
      the much needed government baggage train, moved into a position 200 paces
      from Cope’s army and, at dawn, attacked from an unexpected direction. The
      Jacobite Brigade under Murray charged the government forces leaving the
      other Brigades under the Duke of Perth and the reserve, under the command
      of Charles to follow and support. The Government artillery fire was
      ineffective and brief as the crews fled, followed soon by the dragoons on
      both flanks of the infantry in the center. The infantry held briefly then
      fled or surrendered. The engagement lasted approximately 15 minutes. Both
      sides consisted of approximately 2,500 men. Jacobite losses were
      approximately 25 killed. Government losses were approximately 150 killed
      with over 1,000 captured. English dragoon horses were slaughtered by
      Highland soldiers denying mounts for Jacobite cavalry. There was some
      desertion of Scots fighting for the government to the Jacobite army, but
      the numbers are not clear. Allegations of Jacobite soldiers killing
      wounded government soldiers after the battle were made but cannot be
      substantiated in the literature. What is important is that government
      soldiers believed the allegations and this influenced their behavior
      following the battle of Culloden.
    </p>
    <p class="center">* * *</p>
    <p>
      Following Prestonpans, land owners in the Lowlands under Jacobite control
      were required to contribute towards the equipping and raising of
      regiments. This levy changed the character of the Jacobite army. Of those
      forces raised in Scotland, approximately half were Lowland and half were
      Highland in origin. All soldiers were expected to adopt Highland dress,
      including the English Manchester Regiment which wore bonnets and plaids
      over their shoulders. Highland dress was used in 1689, 1715 and 1745 to
      indicate support for the Jacobite cause. Highland attire, it was hoped,
      would also intimidate English opponents on the field of battle. It is not
      possible to establish the proportion of men forced into Jacobite military
      service with any degree of certainty. What is beyond doubt is that it
      occurred.
      <br>
      <br>The emissary Charles sent to France described the victory of
      Prestonpans in such glowing terms and reported that the Jacobite army was
      so large that many French Ministers believed that their support was
      unnecessary. Cope’s defeat energized the English Government and
      expressions of support and money were forthcoming from all strata of
      society. On 23 September, General Ligonier arrived in England with 10
      regiments from the continent. The generally combat ineffective English
      militia was mustered, not so much to engage in combat, but to keep the
      peace locally and forestall local insurrection. Catholics were disarmed
      and ordered to leave the large population centers of England. General Wade
      moved to Newcastle with an English army of approximately 8,000 to cover
      the eastern approaches to the English border and was in place by the end
      of October. General Ligonier established a blocking position in Lancashire
      with approximately 10,000 soldiers.
      <br>
      <br>The Jacobite Council of War agreed to take the army south into
      England based on Charles’ claim of English support and a French invasion
      of England. The Scottish commanders on the council had not anticipated an
      invasion of England, but in the face of Charles insistence, relented.
      There was an economic aspect to the invasion as well, because the army
      needed whatever financial support could be gained from English towns in
      order to support itself. Lord Strathallan was left in Scotland as
      commander in chief. Smugglers delivered 2,500 firelocks to the Jacobite
      army at Montrose just in time to equip the Jacobite forces invading
      England. The Jacobite army departed Edinburgh on 31 October with
      approximately 6,000 men.
      <br>
      <br>The Jacobite army moved south in two columns with the western column
      moving through Peebles and Moffat. The eastern most column, under Charles,
      went through Kelso and Jedburg. The two columns linked up at Longtown and
      arrived at Carlisle on 9 November. Carlisle surrendered on the 14th after
      a 4 day siege and the castle surrendered the following day. The Duke of
      Perth, a Catholic, was given the privilege of accepting the surrender of
      Carlisle despite warnings from Lord Murray. The Government, as expected,
      made much of the first city taken by the Jacobites in England being
      surrendered to a Catholic. On the 20th the Jacobite army continued south.
      <br>
      <br>On 26 November Lord John Drummond and 800 soldiers in French service
      comprised of the Royal Ecossois as well as a company of 50 men from four
      of the six regiments in the Irish Brigade, referred to as the Irish
      Picquets, arrived in Scotland and garrisoned Perth. By 27 November the
      Jacobite army was resting in Preston with none of the English Jacobites
      flocking to join them as Charles had predicted. The following day an
      English deserter in the Jacobite army, Sergeant Dickson, pushed ahead of
      the main body and with his girlfriend and a drummer captured Manchester
      for Charles. Manchester provided the only support to Charles contributing
      the Manchester Regiment, consisting of 200 men commanded by Colonel
      Francis Townley.
      <br>
      <br>On 28 November, the Duke of Cumberland replaced an ailing Ligonier
      and took command of the government forces in Lancashire. He was shortly
      out maneuvered by the Jacobite army which slipped by him south into Derby.
      The Jacobite army entered Derby on 4 December, 125 miles from London.
      Charles and his Irish advisors called for a march on London and his
      Scottish field commanders called for a withdrawal to Scotland in the face
      of two armies in the field, either of which outnumbered the Jacobite army.
      Cumberland was at Coventry with approximately 9,000 men and Wade was at
      Wetherby with approximately 6,500 men. The council was also told of a
      nearby fictional third field army from a double agent. There was an army
      gathering north of London with the Guards Regiments as its core
      formations. There was no indication London, a city of over 50,000 people,
      would be supportive of the Jacobite cause. Beginning on 2 December France
      began assembling a force of perhaps as many as 15,000 at Dunkirk for an
      invasion of England. A shortage of transport, lack of artillery, internal
      discord over the invasion was more important than the war in Flanders,
      and, finally, English naval interdiction prevented the invasion. The march
      back to Scotland began on 6 December 1745 after violent disagreement in
      the War Council.
      <br>
      <br>The march south into England had been for the most part unopposed
      with the exception of militia units destroying bridges and roadways in the
      Jacobite Army’s path. Towns and cites along the army’s route of march had
      grudgingly supplied and housed the army and local Jacobites had shown some
      hospitality to Charles and his officers. The march north was entirely
      different. The army received a violent reception in many communities and
      was forced to defend itself on more than one occasion. Stragglers were
      killed and the Jacobite Army resorted to looting in the absence of
      voluntary support. Manchester, the only English town that had provided
      soldiers to the Jacobite army, closed its gates to the army as it made its
      way north. Charles deliberately slowed his pace, and, therefore, that of
      his army, in order to avoid giving the appearance of fleeing England,
      putting his soldiers at risk from the hostile local population.
      <br>
      <br>In the absence of Charles and his army, much of Scotland either
      reverted to government control or experienced a marked loss of Jacobite
      enthusiasm. Government Independent Companies, recruited from Clans Munro,
      Grant, MacKay, MacLeod and MacKenzie gathered at Inverness and by early
      December numbered 10 companies of approximately 1,000 men. On 10 December,
      a force of 700 men from the Independent Companies moving to Aberdeen was
      defeated at Inverurie by Lord Lewis Gordon’s Regiment and the Royal
      Ecosse, forcing them to retreat to Elgin and leaving the Jacobites in
      control of Aberdeen and its environs. Campbell of Mamore raised a militia
      in Argyllshire of 1,000 men in December as well. On 12 December, the
      garrison of Edinburgh Castle was reinforced and the government regained
      control of the city. Lord Loudon and a force of 600 men from the
      Independent Companies took Fort Augustus from Lord Lovat’s Regiment in
      December.
      <br>
      <br>On 13 December, government volunteer cavalry under General
      Oglethorpe attacked the Jacobite rear guard as the army was departing
      Preston. Elcho’s Horse and Cluny Mac Pherson’s Regiment forced them to
      withdraw. On 18 December the Jacobites rear guard near Clifton, under the
      command of Murray, was under pressure from Cumberland’s dragoons. Murray
      established a defensive position with the Atholl Brigade, the Stuarts of
      Appin Regiment, Cluny MacPherson’s Regiment and MacDonald of Glengarry’s
      Regiment, exchanging fire with the dragoons. After dark, Cumberland’s
      dragoons advanced while firing until Murray led the Appins and
      MacPherson’s men in a charge, closing with the dragoon’s, forcing them to
      flee. Murray ordered a retreat and Cumberland occupied Clifton but was
      unable to pursue the retreating Jacobite army.
      <br>
      <br>The Manchester Regiment, with attached companies, stayed at Carlisle
      as the main body of the Jacobite army crossed into Scotland on 20
      December. Charles insisted that the city and castle be garrisoned, perhaps
      as a gesture that he would return to England shortly. The garrison
      surrendered to the Duke of Cumberland on 30 December after a nine day
      siege. The English Jacobite troops were sent to London where the officers
      were condemned to a traitor’s death and the men either joined the
      government army or were transported to the West Indies.
      <br>
      <br>On Christmas Day the Jacobite army entered Glasgow and stayed for 10
      days while the strongly pro-government city was reluctantly forced to
      refit it. There was talk of burning this hostile city, which was saved as
      a result of Lochiel’s efforts. On 4 January, Drummond and his forces
      linked up with Charles and the rest of the Jacobite army. On departing
      Glasgow the Jacobite army went to Stirling and began a siege of Stirling
      Castle on 7 January. General Hawley came out of Edinburgh with a force of
      8,500 and Charles moved to meet him with a force of 8,000 men leaving
      approximately 1,000 to maintain the siege of Stirling.
    </p>
    <h3>Falkirk</h3>
    <p>
      Charles, having little remaining faith in his subordinate commanders, took
      personal command of the Jacobite Army. He waited 2 days for Hawley at
      Bannockburn and then moved on to Falkirk Muir, occupying the high ground 2
      miles away from the government forces on 16 January. The government forces
      were caught off guard and moved to engage the Jacobite army, getting their
      artillery mired in the process. The Jacobite right was anchored on soft
      ground. The government forces deployed down hill from the Jacobites and
      their line was behind a ravine on their right. The Jacobite right flank
      overlapped the government left and the government right overlapped the
      Jacobite left.
      <br>
      <br>The action began with Lord Murray on the right flank firing on and
      charging the government dragoon regiments on the government left. The
      dragoons fled the field carrying the infantry they retreated through and
      trampled with them. The Jacobite formations continued their pursuit and
      were unavailable to support the rest of the army as it faced those
      regiments that had not broken and fled. The right flank government forces
      withdrew in an orderly fashion and the Jacobite army was only able to
      pursue them as far as Falkirk due to onset of darkness, exhaustion,
      disorganization and bad weather. The engagement lasted 20 minutes.
      Hawley’s force had 420 killed and numerous wounded. Charles’ army had
      approximately 50 killed and 60 to 80 wounded. After the government forces
      fled, the Jacobite commanders were unable to reorganize their forces and
      follow up with a move to Edinburgh the following day. The government
      baggage train in the town of Falkirk was looted and large numbers of
      highland soldiers left for home with their loot, as was their tradition.
    </p>
    <p class="center">* * *</p>
    <p>
      The siege of Stirling castle resumed and Murray remained at Falkirk with
      the rapidly shrinking highland regiments. Charles remained at Bannockburn
      House with the lowland regiments, which were also subject to desertion. In
      late January, Cumberland took command of the government forces in and
      around Edinburg and was reinforced. The Highland commanders needed time to
      regroup their forces depleted by desertion and made a strong case for the
      army to move north to Inverness. Charles was against this retreat but was
      grudgingly forced to accept the logic behind the decision.
      <br>
      <br>Charles split the Jacobite army with half accompanying him and half
      with Murray up the coast road. Cumberland followed the coast road from
      Stirling to Perth, Dundee, and Aberdeen plundering, killing and detaining
      any suspected persons of Jacobite sympathies. On 10 February Gordon of
      Glenbucket besieged Ruthven Barracks, captured it and burned it to the
      ground. Loudon with a government force of 1500 attacked the Jacobite army
      headquarters at Moy on the night of 16 February. Loudon’s force was
      spooked by five shouting servants and fled to Inverness. Loudon withdrew
      from Inverness on the 17th and the Jacobite army occupied the city shortly
      thereafter. Loudon’s forces retreated to Dornoch where they were surprised
      on 20 February and forced to retreat to the Isle of Skye.
      <br>
      <br>Cumberland believed the rebellion was over until the Jacobite
      capture of Inverness. Realizing that it was not over he established his
      headquarters at Aberdeen and began massing his forces remaining in the
      city from 27 February until 8 April. Charles was in the process of massing
      forces as well in Inverness.
      <br>
      <br>The Jacobite army also began operations in the Great Glen against
      the government forts there. Fort George, the northernmost fort, fell
      shortly after the occupation of Inverness. Fort Augustus, in the Great
      Glen, fell to the Jacobites on 7 March after a two day siege. Lochiel
      besieged Fort William from 20 March to 3 April, giving up the siege after
      failing to cut off re-supply of the garrison by water and losing their
      guns to a sally from the fort on 31 March. Lochiel and his men remained in
      Lochaber until being recalled by Charles to Inverness in April.
      <br>
      <br>Murray conducted several raids in Atholl as well as a siege of Blair
      Castle from 12 March to 2 April. He lacked the artillery to end the siege
      successfully, and Charles refused to provide additional forces to support
      large scale offensive operations, forcing Murray to withdraw to Inverness.
      <br>
      <br>The Royal Navy was making its presence felt by successfully
      preventing re-supply, reinforcement and money from reaching the
      increasingly desperate Jacobite army. Cumberland’s army was by contrast
      well supplied, paid and increasing in size. Cumberland was training his
      infantry formations to respond to a highland charge by stabbing with
      bayonet to the right into the exposed abdomen of attacking swordsmen. This
      technique presupposed a well trained formation of relatively calm soldiers
      who trust those to their left and right.
      <br>
      <br>Cumberland moved north across the Spey unopposed on 12 April as
      Perth and Drummon’s Jacobite force retreated to Elgin and beyond. By the
      14th Cumberland’s army of approximately 9,000 men was at Nairn, well
      rested and re-supplied by sea on a regular basis. Charles brought his army
      out of Inverness and moved it to Culloden Park. There were only 12 miles
      between the two armies. Murray recommended establishing a position on a
      piece of thoroughly examined boggy, hilly terrain, making deployment of
      horse and cannon problematic for Cumberland but was overruled by Charles
      who chose an open moor south east of Culloden House recommended by
      O’Sullivan. Charles’ army was unpaid, hungry and sleeping on open ground
      with stockpiles of food sitting in Inverness.
      <br>
      <br>At 8 PM on 15 April, 3,500 men of the Jacobite army attempted a
      cross country move in total darkness in order to conduct a surprise attack
      on Cumberland’s army in hopes it would be unprepared, having celebrated
      Cumberland’s birthday that evening. The army moved in two columns, Murray
      leading, and Charles following. Murray’s column consisted of highlanders,
      who were clearly in their element conducting such operations. Charles
      column consisted in part of the French provided regulars who proved to be
      unused to night cross country movement and lagged behind. By 2 AM,
      Murray’s column was approximately 3 miles for Cumberland’s alert pickets
      and Charles column was as much has half a mile behind. As the pre dawn
      light became brighter, Murray gave the order to turn around. By 5 AM the
      Jacobite army had returned to Culloden and was scattering to find food,
      sleep and shelter. Cumberland’s army advanced and Charles, despite the
      advice given him by all his subordinate commanders, decided to stay and
      fight, mustering approximately 4,500 exhausted, hungry men to face
      Cumberland’s army of twice its size.
    </p>
    <h3>Culloden</h3>
    <p>
      Cumberland’s early deployment on the move forced Charles to occupy terrain
      that had not been examined west of the position occupied on the 14th, a
      mile and a half south of Culloden House. The Jacobite army deployed in two
      ranks. There was a sleet and rain mixture blowing in their faces. In the
      first rank, the right wing was commanded by Murray and the left by Perth.
      The second line was commanded by General Stapleton, in three separate
      formations as opposed to a single line due to a shortage of men. There
      were three four gun artillery batteries in the center and wings of the
      front line. The government forces deployed in two solid ranks with
      artillery interspersed in 2 gun batteries between the five front line
      regiments. Government cavalry was positioned on both flanks with Argyll
      Militia and the Independent Companies positioned on the left flank.
      <br>
      <br>After the Jacobite opening rounds at 1 o’clock, the government
      artillery opened fire disabling the Jacobite artillery and causing a few
      casualties in the increasingly anxious stationary infantry. Charles
      repositioned to place of safety, but from which he could not observe his
      forces. After withstanding 10 to 15 minutes of sustained artillery fire
      the Jacobite right charged without orders. There was a ripple effect
      across the Jacobite front as each regiment in turn joined the charge. As
      the Jacobite forces came within 300 meters of the government forces they
      were hit with as many as 5 to 6 volleys of grapeshot. Once they came
      within 50 meters they were hit with at least two volleys of musket fire
      before closing with the government forces on their right. As the Jacobite
      front line closed with the government forces, the center veered right in
      the face of heavy fire. The Jacobite left was unable to close with the
      government forces due to heavy fire and swampy intervening terrain.
      <br>
      <br>The heavily depleted right flank, however, did close with Barrel’s
      and Munro’s regiments. Barrels regiment was depleted and retreated.
      Monro’s held formation with the first rank at “charged bayonets” and the
      second and third rank firing as many as nine volleys point blank into
      Cameron of Lochiel’s Regiment, Stuart's of Appin Regiment, the Atholl
      Brigade, Lady MacIntosh's Regiment, Lord Lovat's Regiment that had closed
      with the government forces. Four second rank regiments reinforced Barrels
      and Monro’s regiments surrounding the Jacobites on three sides subjecting
      them to as many as 1,200 muskets firing in ranks.
      <br>
      <br>The Argyll Militia and Independent Companies broke down the wall of
      the enclosure on the Jacobite right, allowing for flanking fire on the
      attacking Jacobite first line and the repositioning of the Government
      horse to outflank the Jacobite army. Part of the right most second rank of
      the Jacobite army responded and held off the Government horse. In doing
      so, they were unable to reinforce the attack of the Jacobite front line
      against the government main body. Within 40 minutes it was over. Charles
      fled the field, his army retreated, for the most part disintegrating and
      pursued by the government horse and foot. The French forces held off the
      government forces long enough for more of the Jacobite army to disperse
      than otherwise might have been possible. Cumberland’s army killed anything
      they saw for two days after the battle. The Estimates vary from 1,500 to
      3,000 men of the Jacobite army killed during and in the pursuit after
      battle. Approximately 310 men of Cumberland’s army were killed.
    </p>
    <p class="center">* * *</p>
    <p>
      Charles fled the field and spent five months on the run in Scotland before
      sailing to France. On the 20th of April the remainder of the Jacobite
      army, approximately 1,500 men rallied at Ruthven barracks and from there
      dispersed. English government forces ravaged Scotland, making little or no
      distinction between those who had remained loyal and those who had been in
      the uprising. Scots who had supported the government in many cases did
      their best to defend those who had participated in the uprising from the
      worst of the English army’s atrocities. Many of the Jacobite nobles fled
      for France and only four were executed. A total of approximately 3,500
      prisoners, men women and children were taken into custody and send to
      England for trial. Of the officers, fifty two were executed and all twenty
      four officers in the Manchester Regiment were executed at traitors. Of the
      other prisoners, those that did not die in captivity were transported to
      the colonies or released by 1747.
      <br>
      <br>Parliament passed laws against the carrying of arms, suppressed the
      Episcopal Church and transformed the traditional clan nobility into land
      lords. Charles Edward Stuart died on 30 Jan 1788. His brother, Henry,
      became a Catholic priest not long after the uprising ending any slim hope
      of a Stuart return to the Throne of England, Scotland and Ireland. Henry
      died in 1807.
    </p>
    <h4 class="pointer" @click="jacobite = !jacobite">Jacobite Regiments 1745-46 &#9662;</h4>
    <p v-show="!jacobite">
      <span class="padding">Atholl Brigade (Nov 1745- Apr 1746)</span>
      <span class="padding">Lord Niarn's Regiment</span>
      <span class="padding">MacLean's Company</span>
      <span class="padding">Lord Murray's Regiment</span>
      <span class="padding">MacLachlan's Battalion</span>
      <span class="padding">Archibald Menzies of Shian's Regiment</span>
      <span class="padding">Prestonpans 21 Sep 1745</span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Siege of Carlisle 9-14 Nov 1745</span>
      <span class="padding">Clifton 17 Dec 1745</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4
      class="pointer"
      @click="scots = !scots"
    >Scots (Bagot’s) Troop of Hussars (Sep 1745-Apr 1746) &#9662;</h4>
    <p v-show="!scots">
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4
      class="pointer"
      @click="cameron = !cameron"
    >Cameron of Lochiel's Regiment (Aug 1745-May 1746) &#9662;</h4>
    <p v-show="!cameron">
      <span class="padding">Prestonpans 21 Sep 1745</span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Siege of Ft William, 20 Mar-3 Apr, 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4 class="pointer" @click="cluny = !cluny">Cluny MacPherson's Regiment (?- May 1746) &#9662;</h4>
    <p v-show="!cluny">
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Preston 13 Dec 1745</span>
      <span class="padding">Clifton 17 Dec 1745</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
    </p>

    <h4 class="pointer" @click="earl = !earl">Earl of Cromartie's Regiment &#9662;</h4>
    <p v-show="!earl">
      <span class="padding">Falkirk, 17 Jan 1746</span>
    </p>

    <h4
      class="pointer"
      @click="lifeguard = !lifeguard"
    >Lifeguard of Horse (Sep-1745-Apr 1746) &#9662;</h4>
    <p v-show="!lifeguard">
      <span class="padding">Lord Elcho’s Troop and Lord Balmerino’s Troop</span>
      <span class="padding">Prestonpans 21 Sep 1745</span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Siege of Carlisle 9-14 Nov 1745</span>
      <span class="padding">Preston 13 December 1745</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4 class="pointer" @click="fitzjames = !fitzjames">Fitzjames Horse &#9662;</h4>
    <p v-show="!fitzjames">
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4
      class="pointer"
      @click="john = !john"
    >John Gordon of Glenbuchat's Regiment (?- Apr 1746) &#9662;</h4>
    <p v-show="!john">
      <span class="padding">Siege of Carlisle 9-14 Nov 1745</span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Siege of Carlisle 9-14 Nov 1745</span>
      <span class="padding">Carlisle Garrison, 1 Company, 22-30 Dec 1745</span>
      <span class="padding">Siege of Ruthven Barracks, 10-14 Feb 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4 class="pointer" @click="irish = !irish">Irish Picquets &#9662;</h4>
    <p v-show="!irish">
      <span class="padding">Dillon's Regiment, 1 Company</span>
      <span class="padding">Ruth's Regiment, 1 Company</span>
      <span class="padding">Lally's Regiment, 1 Company</span>
      <span class="padding">Berwick's Regiment, 1 Company</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Carlisle Garrison, 1 Company, 22-30 Dec 1745</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4
      class="pointer"
      @click="kilmarnock = !kilmarnock"
    >Lord Kilmarnock's Footguard Regiment (Mar 1746- Apr 1746) &#9662;</h4>
    <p v-show="!kilmarnock">
      <span class="padding">Crichton of Auchingould's Battalion</span>
      <span class="padding">Bannerman of Elsick's Battalion</span>
      <span class="padding">Chisolm of Strathglass' Battalion</span>
      <span class="padding">
        Lord Kilmarnock's Troop of Horse (dismounted Mar 1746) (Oct 145- Apr
        1746)
      </span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">
        Lord Pitsligo's Troop of Horse (dismounted Mar 1746) (Oct 145- Apr
        1746)
      </span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Siege of Carlisle 9-14 Nov 1745</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4 class="pointer" @click="lewis = !lewis">Lord Lewis Gordon's Regiment &#9662;</h4>
    <p v-show="!lewis">
      <span class="padding">John Gordon of Avochie's Battalion</span>
      <span class="padding">Francis Farquharson of Monaltrie's Battalion</span>

      <span class="padding">John Moir of Stonywood's Battalion</span>

      <span class="padding">Inverurie, 10 Dec 1745</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4 class="pointer" @click="lovat = !lovat">Lord Lovat's Regiment (Oct 1745- Apr 1746) &#9662;</h4>
    <p v-show="!lovat">
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4
      class="pointer"
      @click="clanranald = !clanranald"
    >MacDonald of Clanranald's Regiment (Aug 1745- Apr 1746) &#9662;</h4>
    <p v-show="!clanranald">
      <span class="padding">Prestonpans 21 Sep 1745</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4
      class="pointer"
      @click="glengarry = !glengarry"
    >MacDonald of Glengarry's Regiment (Aug- 1745- May 1746) &#9662;</h4>
    <p v-show="!glengarry">
      <span class="padding">Grant of Glenmorriston's Battalion</span>
      <span class="padding">MacDonald of Barisdale's Battalion</span>
      <span class="padding">Prestonpans 21 Sep 1745</span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Clifton 17 Dec 1745</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4
      class="pointer"
      @click="keppoch = !keppoch"
    >MacDonald's of Keppoch (Aug 1745- Apr 1746) &#9662;</h4>
    <p v-show="!keppoch">
      <span class="padding">MacDonald of Glencoe’s Battalion</span>
      <span class="padding">Prestonpans 21 Sep 1745</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Siege of Ft William, 20 Mar-3 Apr, 1746</span>
    </p>

    <h4 class="pointer" @click="macgregor = !macgregor">MacGregor's Regiment &#9662;</h4>
    <p v-show="!macgregor">
      <span class="padding">Prestonpans 21 Sep 1745</span>
    </p>

    <h4 class="pointer" @click="macintosh = !macintosh">Lady MacIntosh's Regiment &#9662;</h4>
    <p v-show="!macintosh">
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4 class="pointer" @click="manchester = !manchester">Manchester Regiment (Dec 1745) &#9662;</h4>
    <p v-show="!manchester">
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Carlisle Garrison, 22-30 Dec 1745</span>
    </p>

    <h4 class="pointer" @click="ogilvy = !ogilvy">Lord Ogilvy's Regiment &#9662;</h4>
    <p v-show="!ogilvy">
      <span class="padding">Siege of Carlisle 9-14 Nov 1745</span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Carlisle Garrison, 1 Company, 22-30 Dec 1745</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4
      class="pointer"
      @click="perth = !perth"
    >Duke of Perth's Regiment (Sep 1745- Apr 1746) &#9662;</h4>
    <p v-show="!perth">
      <span class="padding">Prestonpans 21 Sep 1745</span>
      <span class="padding">Siege of Carlisle 9-14 Nov 1745</span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Carlisle Garrison, 2 Companies, 22-30 Dec 1745</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4 class="pointer" @click="ecossois = !ecossois">Royal Ecossois Regiment &#9662;</h4>
    <p v-show="!ecossois">
      <span class="padding">Inverurie, 10 Dec 1745</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4
      class="pointer"
      @click="strathallan = !strathallan"
    >Lord Strathallan’s/Drommond’s Troop of Horse (Aug 1745- Apr 1746) &#9662;</h4>
    <p v-show="!strathallan">
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4
      class="pointer"
      @click="appin = !appin"
    >Stuart's of Appin Regiment (Aug 1745- Apr 1746) &#9662;</h4>
    <p v-show="!appin">
      <span class="padding">Prestonpans 21 Sep 1745</span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Clifton 17 Dec 1745</span>
      <span class="padding">Falkirk, 17 Jan 1746</span>
      <span class="padding">Siege of Ft William, 20 Mar-3 Apr, 1746</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>

    <h4 class="pointer" @click="johnroy = !johnroy">John Roy Stuart's Regiment &#9662;</h4>
    <p v-show="!johnroy">
      <span class="padding">Siege of Carlisle 9-14 Nov 1745</span>
      <span class="padding">Invasion of England, 31 Oct-20 Dec 1745</span>
      <span class="padding">Clifton 17 Dec 1745</span>
      <span class="padding">Carlisle Garrison, 1 Company, 22-30 Dec 1745</span>
      <span class="padding">Culloden 16 Apr 1746</span>
    </p>
    <h3>Government Regiments 1745-46</h3>
    <h4 class="pointer" @click="prestonpans = !prestonpans">Prestonpans, 21 Sep 1745 &#9662;</h4>
    <p v-show="!prestonpans">
      <span class="padding">Gardiner’s Dragoons</span>
      <span class="padding">Guise's</span>
      <span class="padding">Hamilton’s Dragoons</span>
      <span class="padding">Lascelles's</span>
      <span class="padding">Lee's</span>
      <span class="padding">Murray's (Scottish)</span>
      <span class="padding">Loudoun’s (Scottish)</span>
    </p>

    <h4 class="pointer" @click="falkirk = !falkirk">Falkirk, 17 Jan 1746 &#9662;</h4>
    <p v-show="!falkirk">
      <span class="padding">Argyll Militia (Scottish)</span>
      <span class="padding">Barrell's</span>
      <span class="padding">Battereau's</span>
      <span class="padding">Blakeney's</span>
      <span class="padding">Murray’s (Scottish)</span>
      <span class="padding">Chomondley's</span>
      <span class="padding">Cobham’s Dragoons</span>
      <span class="padding">Fleming's</span>
      <span class="padding">Glasgow Militia (Scottish)</span>
      <span class="padding">Hamilton’s Dragoons</span>
      <span class="padding">Howard's</span>
      <span class="padding">Ligonier's</span>
      <span class="padding">Ligonier’s Dragoons</span>
      <span class="padding">Monro's</span>
      <span class="padding">Price's</span>
      <span class="padding">Pulteney's</span>
      <span class="padding">Royals (Scottish)</span>
      <span class="padding">Wolfe's</span>
    </p>

    <h4 class="pointer" @click="culloden = !culloden">Culloden, 16 Apr 1746 &#9662;</h4>
    <p v-show="!culloden">
      <span class="padding">Argyll Militia (Scottish) Monro's</span>
      <span class="padding">Barrell's Price's</span>
      <span class="padding">Battereau's Pulteney’s</span>
      <span class="padding">Blakeney's Royal’s (Scottish)</span>
      <span class="padding">Bligh's Sempill’s (Scottish)</span>
      <span class="padding">Campbell’s (Scottish) Wolfe’s</span>
      <span class="padding">Chomondley's</span>
      <span class="padding">Cobham’s Dragoons</span>
      <span class="padding">Conway’s</span>
      <span class="padding">Fleming's</span>
      <span class="padding">Howard's</span>
      <span class="padding">Independent Companies (Scottish)</span>
      <span class="padding">Keer’s Dragoons</span>
      <span class="padding">Kingston’s Horse</span>
      <span class="padding">Ligonier’s Dragoons</span>
      <span class="padding">Loudoun’s (Scottish)</span>
    </p>
    <hr>
    <h3>Sources:</h3>
    <ol>
      <li>Black, Jeremy, Culloden and the ’45, Guild Publishing, London, 1990</li>
      <li>
        Carlton, Charles, Charles I, The Personal Monarch, Routledge, London,
        1995
      </li>
      <li>
        Coote, Stephen, Royal Survivor, The Life of Charles II, Palgrave Press,
        UK, 1999
      </li>
      <li>
        Cowan, Edward J., Montrose for Covenant and King, Cannongate, Edinburgh,
        1977
      </li>
      <li>
        Douglas, Hugh, Jacobite Spy Wars, Moles Rogues and Treachery, Sutton,
        UK, 1999
      </li>
      <li>
        Gibson, John, Lochiel of the 45, Edinburgh University Press, Edinburgh,
        1994
      </li>
      <li>
        Gibson, John, Playing the Scottish Card, The Franco-Jacobite Invasion of
        1708, Edinburgh University Press, Edinburgh, 1988
      </li>
      <li>
        Johnstone, James, Memoirs of the Rebellion in 1745 and 1746, Longman,
        London, 1820
      </li>
      <li>Kemp, Hilary, The Jacobite Rebellion, Almark, London, 1975</li>
      <li>
        Lenman, Bruce, The Jacobite Rising in Britain, 1689-1745, Methuen,
        London, 1984
      </li>
      <li>
        Livingston, Alastair, ed. No Quarter Given, The Muster Rolls of Prince
        Charles Edward Stuart’s Army, 1745-46, Neil Wilson Publishing, Glasgow,
        2001
      </li>
      <li>
        Lord, Evelyn, The Stuarts’ Secret Army, English Jacobites 1689-1753,
        Pearson, Harlow, 2004
      </li>
      <li>
        McCall, Colin, Routes, Roads, Regiments, and Rebellion, A Brief History
        of the life and work of General George Wade (1673-1748) the Father of
        the Military Roads in Scotland, SOLCOL, Derbyshire, 2003
      </li>
      <li>
        McLynn, Frank, The Jacobite Army in England, 1745 The Final Campaign,
        John Donald Publishers, Edinburgh, 1998
      </li>
      <li>Miller, John, James II, A Study in Kingship, Methuen,London, 1999</li>
      <li>
        Pittock, Murray, The Myth of the Jacobite Clans, Edinburgh University
        Press, Edinburgh, 1995
      </li>
      <li>
        Reid, Stuart, The Scottish Jacobite Army, 1745-46, Osprey Publishing,
        UK, 2006
      </li>
      <li>
        Reid, Stuart, 1745: A Military History of the Last Jacobite Rising,
        Sarpedon, New York, 1966
      </li>
      <li>
        Roberts, John, The Jacobite Wars, Scotland and the Military Campaigns of
        1715 and 1745, Polygon, Edinburgh, 2002
      </li>
      <li>
        Scott-Moncrieff, Lesley, ed. The 45, To Gather an Image Whole, Mercat
        Press, Edinburgh, 1998
      </li>
      <li>
        Simpson, Peter, The Independent Highland Companies, 1603-1760, John
        Donald Publishing, Edinburgh, 1996
      </li>
      <li>
        Speck, W.A. The Butcher, The Duke of Cumberland and the suppression of
        the 45, Welsh Academic Press, Caernafon, Wales, 1995
      </li>
      <li>
        Stewart, Alan, The Cradle King, The Life of James IV and I the First
        Monarch of a United Great Britain, St. Martins Press, New York, 2003
      </li>
      <li>
        Szechi, Daniel, 1715 The Great Jacobite Rebellion, Yale University
        Press, New Haven, 2006
      </li>
      <li>
        Tomasson, Katherine, The Jacobite General, William Blackwood and Sons,
        Edinburgh, 1958
      </li>
      <li>
        Tomasson, Katherine and Buist, Francis, Battle of the 45, Book Club
        Associates, London, 1978
      </li>
      <li>Van Der Kiste, John, William and Mary, Sutton, UK, 2003</li>
      <li>
        Waller, Maureen, Ungrateful Daughters, The Stuart Princesses who stole
        their Fathers Crown, St Martins Press, New York, 2002
      </li>
      <li>
        Whatley, Christopher, Bought and Sold for English Gold, Explaining the
        Union of 1707, Tuckwell Press, Scotland, 1994
      </li>
    </ol>
    <h3>Recommended Reading:</h3>
    <h4>Contemporary Accounts</h4>
    <ul>
      <li>Burt, Edward, Letters from the North of Scotland (1754)</li>
      <li>Forbes, Robert, The Lyon in Mourning (1775)</li>
      <li>
        Johnstone, Chevalier de, A Memoir of the Forty-Five (Folie Society,
        1958)
      </li>
    </ul>
    <h4>Narratives</h4>
    <ul>
      <li>
        Douglas, Hugh, Jacobite Spy Wars, Moles Rogues and Treachery (Sutton,
        1999)
      </li>
      <li>
        Ferguson, W. M., Scotland, 1698 to the Present (Edinburgh History of
        Scotland, Vol. 4, Praeger, 1968)
      </li>
      <li>
        Hook, Michael and Ross, Walter, The Forty Five, the Last Jacobite
        Rebellion (The National Library of Scotland, 1995)
      </li>
      <li>Kemp, Hilary, The Jacobite Rebellion (Almark Pub. Co., 1975)</li>
      <li>Lenman, Bruce, The Jacobite Rising in Britain, 1689-1745 (Metheun, 1984)</li>
      <li>
        Lord, Evelyn, The Stuarts’ Secret Army, English Jacobites 1689-1753,
        (Pearson, 2004)
      </li>
      <li>Mackie, R. L., A Short History of Scotland (Praeger, 1962)</li>
      <li>
        Pittock, Murray, The Myth of the Jacobite Clans (Edinburgh University
        Press, 1995)
      </li>
      <li>
        Reid, Stuart, 1745: A Military History of the Last Jacobite Rising
        (Sarpedon, 1966)
      </li>
      <li>
        Reid Stuart, Like Hungry Wolves, Culloden Moor 16 April 1746 (Windrow
        and Greene, 1994)
      </li>
      <li>
        Roberts, John, The Jacobite Wars, Scotland and the Military Campaigns of
        1715 and 1745 (Polygon, 2002)
      </li>
      <li>
        Scott-Moncrieff, Lesley, ed. The 45, To Gather an Image Whole, (Mercat
        Press, 1998)
      </li>
      <li>
        Simpson, Peter, The Independent Highland Companies, 1603-1760, (John
        Donald Publishing,1996)
      </li>
      <li>
        Speck, W.A. The Butcher, The Duke of Cumberland and the suppression of
        the 45 (Welsh Academic Press, 1995)
      </li>
      <li>
        Tomasson, Katherine & Buist, Francis, Battles of the '45 (Batsford,
        1962)
      </li>
    </ul>
    <h4>Personalities</h4>
    <ul>
      <li>Gibson, John, Lochiel of the 45 (Edinburgh University Press, 1994)</li>
      <li>
        McCall, Colin, Routes, Roads, Regiments, and Rebellion, A Brief History
        of the life and work of General George Wade (1673-1748) the Father of
        the Military Roads in Scotland,(SOLCOL, Derbyshire, 2003)
      </li>
      <li>Tomasson, Katherine, The Jacobite General (Blackwood, 1958)</li>
    </ul>
    <h4>Militaria</h4>
    <ul>
      <li>Caldwell, David, The Scottish Armoury (Blackwood, 1979)</li>
      <li>
        Campbell, Lord Archibald, Scottish Swords from the Battlefield at
        Culloden (Mobray, 1971)
      </li>
      <li>
        Forman, James D., The Scottish Dirk (Historical Arms Series No. 26,
        Museum Restoration Service, 1991)
      </li>
      <li>
        Livingston, Alastair, ed. No Quarter Given, The Muster Rolls of Prince
        Charles Edward Stuart’s Army, 1745-46,( Neil Wilson Publishing, 2001)
      </li>
      <li>
        National Trust for Scotland, The, Culloden: The Swords and The Sorrows
        (The National Trust for Scotland Trading Co. Ltd., 1996)
      </li>
      <li>
        Nicholson, Robin, Curator, Bonnie Prince Charlie and the Royal House of
        Stuart, 1688-1788 (The Drambuie Liqueur Company, LTD., 2002)
      </li>
      <li>Wallace, John, Scottish Swords & Dirks (Stackpole, 1970)</li>
      <li>
        Woosnam-Savage, Robert C., ed., 1745: Charles Edward Stuart and the
        Jacobites (Glasgow Museums, 1995)
      </li>
    </ul>
    <h4>Stuart-Jacobite Background</h4>
    <ul>
      <li>Carlton, Charles, Charles I, The Personal Monarch, (Routledge, 1995)</li>
      <li>
        Coote, Stephen, Royal Survivor, The Life of Charles II, (Palgrave Press,
        1999)
      </li>
      <li>Cowan, Edward J., Montrose for Covenant and King, (Cannongate, 1977)</li>
      <li>Miller, John, James II, A Study in Kingship, (Methuen, 1999)</li>
      <li>
        Stewart, Alan, The Cradle King, The Life of James IV and I the First
        Monarch of a United Great Britain, (St. Martins Press, 2003)
      </li>
      <li>
        Szechi, Daniel, 1715 The Great Jacobite Rebellion, (Yale University
        Press, 2006)
      </li>
      <li>
        Waller, Maureen, Ungrateful Daughters, The Stuart Princesses who stole
        their Fathers Crown, (St Martins Press, 2002)
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jacobite: true,
      scots: true,
      cameron: true,
      cluny: true,
      earl: true,
      lifeguard: true,
      fitzjames: true,
      john: true,
      irish: true,
      kilmarnock: true,
      lewis: true,
      lovat: true,
      clanranald: true,
      glengarry: true,
      keppoch: true,
      macgregor: true,
      macintosh: true,
      manchester: true,
      ogilvy: true,
      perth: true,
      ecossois: true,
      strathallan: true,
      appin: true,
      johnroy: true,

      prestonpans: true,
      falkirk: true,
      culloden: true
    };
  }
};
</script>

<style lang="scss" scoped></style>
